const FREE_WIFI_AMENITIES = ['WC', 'W4']
const PET_OK_AMENITIES = ['t1']
const SHOPPING_AMENITIES = ['S1', 'S2', 'S3', 'S4', 'S5', 'S6']
const FITNESS_GYM_AMENITIES = ['G0']
const SMOKING_SPACE_AMENITIES = ['M0', 'M1']
const PICKUP_DROP_OFF_SERVICE_AMENITIES = [
  'T0',
  'T1',
  'T2',
  'T3',
  'T4',
  'T5',
  'T6',
  'T7',
  'T8',
  'T9',
  'TA',
  'TB',
  'TC',
  'TD',
  'TE',
  'TF',
  'TG',
  'TH',
]
const LAUNDRY_SERVICE_AMENITIES = ['U0', 'U1']
const RESTAURANT_AMENITIES = ['N0']
const BAR_AMENITIES = ['R5']
const POOL_AMENITIES = ['PJ', 'PL', 'PQ']
const OUTDOOR_BATH_AMENITIES = ['H2', 'H3', 'H6', 'H7', 'HF']
const PARKING_AMENITIES = ['KI', 'K1', 'KJ']
const ROOM_SERVICE_AMENITIES = ['F0', 'F1', 'F2']
const BARRIER_FREE_AMENITIES = ['EI']
const HOT_SPRING_AMENITIES = ['t5', 't6']
const DIRECT_CONNECT_SKI_AMENITIES = ['s1']
const BREAKFAST_INCLUDED_AMENITIES = [
  'B1',
  'B2',
  'B3',
  'B4',
  'B5',
  'B6',
  'B7',
  'B8',
  'B9',
  'AA',
  'AB',
  'BA',
  'BF',
  'BH',
  'BB',
]
const SAUNA_AMENITIES = ['u1', 'u2', 'u3']
const MASSAGE_AMENITIES = ['p4']

const ALL_FACILITIES_AND_SERVICES = [
  {
    id: 1,
    mappingIds: HOT_SPRING_AMENITIES,
    name: '温泉',
  },
  {
    id: 2,
    mappingIds: BREAKFAST_INCLUDED_AMENITIES,
    name: '朝食付き',
  },
  {
    id: 3,
    mappingIds: FREE_WIFI_AMENITIES, // Free Wi-Fi
    name: 'WiFi無料',
  },
  {
    id: 4,
    mappingIds: PET_OK_AMENITIES,
    name: 'ペットと泊まる',
  },
  {
    id: 5,
    mappingIds: POOL_AMENITIES,
    name: 'プール',
  },
  {
    id: 6,
    mappingIds: DIRECT_CONNECT_SKI_AMENITIES,
    name: 'ゲレンデ直結',
  },
  {
    id: 7,
    mappingIds: PARKING_AMENITIES,
    name: '駐車場付き',
  },
  {
    id: 8,
    mappingIds: BAR_AMENITIES, // Bar
    name: 'バー付き',
  },
  {
    id: 9,
    mappingIds: RESTAURANT_AMENITIES,
    name: 'レストラン付き',
  },
  {
    id: 10,
    mappingIds: SAUNA_AMENITIES,
    name: 'サウナ付き',
  },
  {
    id: 11,
    mappingIds: FITNESS_GYM_AMENITIES,
    name: 'フィットネス設備',
  },
  {
    id: 12,
    mappingIds: MASSAGE_AMENITIES,
    name: 'マッサージ',
  },
]

const EXCLUDED_BY_SERVICE = {
  VP: [4],
}
export const getSupportFacilitiesByService = (service) => {
  if (EXCLUDED_BY_SERVICE[service]) {
    const excludedServices = EXCLUDED_BY_SERVICE[service]
    return ALL_FACILITIES_AND_SERVICES.filter(
      (service) => !excludedServices.includes(service.id)
    )
  }
  return ALL_FACILITIES_AND_SERVICES
}

export default {
  FREE_WIFI_AMENITIES,
  PET_OK_AMENITIES,
  SHOPPING_AMENITIES,
  FITNESS_GYM_AMENITIES,
  SMOKING_SPACE_AMENITIES,
  PICKUP_DROP_OFF_SERVICE_AMENITIES,
  LAUNDRY_SERVICE_AMENITIES,
  RESTAURANT_AMENITIES,
  BAR_AMENITIES,
  POOL_AMENITIES,
  OUTDOOR_BATH_AMENITIES,
  PARKING_AMENITIES,
  ROOM_SERVICE_AMENITIES,
  BARRIER_FREE_AMENITIES,
  HOT_SPRING_AMENITIES,
  ALL: ALL_FACILITIES_AND_SERVICES,
}
